<template>
    <div
        class="home"
        :class="{
            tmr: tmrMode,
        }"
        @click="sensorsClick"
    >
        <img src="./banner@2x.png" alt="" />
        <section>
            <ul>
                <li class="flex-box box-shadow">
                    <img src="./1@2x.png" alt="" />
                    <div>
                        <br />
                        <p>测试结果更精准</p>
                        <span>
                            招商信诺专业精算团队，接入社保、医疗等大数据，倾情推出336人身保险保障指南
                        </span>
                    </div>
                </li>
                <li class="flex-box box-shadow">
                    <div>
                        <br />
                        <p>报告解读更专业</p>
                        <span
                            >专属顾问1V1为您解读分析报告，<br />并为您规划家庭保障</span
                        >
                    </div>
                    <img src="./2@2x.png" alt="" />
                </li>
            </ul>
            <div class="flex-box btn-box">
                <template v-if="tmrMode">
                    <div @click="bindInsurance" sensors-click>
                        {{
                            relateInfo.isRelate
                                ? "下载我的保单详情"
                                : "了解我的保单详情"
                        }}
                    </div>
                </template>
                <template v-else>
                    <router-link sensors-click to="/insurance-guide" tag="div"
                        >了解336保障指南</router-link
                    >
                </template>
                <router-link
                    to="/question"
                    v-if="!$store.state.answer.complete"
                    tag="div"
                    sensors-click
                    >开始保障测评</router-link
                >
                <router-link to="/user-report" v-else tag="div" sensors-click
                    >查看测评结果</router-link
                >
            </div>
            <template v-if="tmrMode">
                <router-link
                    sensors-click
                    to="/insurance-guide"
                    class="guide-btn"
                    tag="a"
                    >了解336保障指南</router-link
                >
            </template>
        </section>
        <div v-if="tmrId">
            <pdf-preview-dialog
                ref="dialog"
                @confirm="pdfPreview"
            ></pdf-preview-dialog>
        </div>
        <doc-preview-dialog ref="docDialog"></doc-preview-dialog>
    </div>
</template>

<script>
import envs from "../../utils/envs.js";
import { getEnvName } from "../../utils/env.js";
import { getUserAnswer } from "../../services/question.js";
import { mapGetters } from "vuex";
import qs from "qs";
import PdfPreviewDialog from "../../components/pdf-preview-dialog/PdfPreviewDialog.vue";
import DocPreviewDialog from "../../components/doc-preview-dialog/DocPreviewDialog.vue";

export default {
    data() {
        return {
            data: null,
            tmrId: "",
            dialogShow: false,
        };
    },
    created() {
        let query = qs.parse(location.search.slice(1));
        query.tmrId && (this.tmrId = query.tmrId);
        this.$store.state.relateInfo = {};
        console.log(navigator.userAgent);
        getEnvName().then((envName) => {
            const login = envs[envName]?.login;
            login &&
                login.isLogin().then(
                    () => {
                        this.$store.dispatch("GET_RELATE_INFO");
                        getUserAnswer((data) => {
                            if (!data.hasAuthorize) {
                                this.$refs.docDialog.show = true;
                            }
                        });
                    },
                    () => {
                        login.goToLogin();
                    }
                );
        });
    },
    computed: {
        ...mapGetters({ relateInfo: "GET_RELATE_INFO" }),
        tmrMode() {
            return (
                this.tmrId &&
                (this.relateInfo.hasNetGuarantee || !this.relateInfo.isRelate)
            );
        },
    },
    mounted() {
        // this.$refs.docDialog.show = true;
        // this.$nextTick(() => {
        //     this.$refs.dialog.download = false;
        //     this.$refs.dialog.show = true;
        // });
        // setTimeout(() => {
        //     this.$store.state.relateInfo.isRelate = true;
        // }, 3000);
    },
    methods: {
        sensorsClick(e) {
            e.stopPropagation();
            let target = e.target;
            if (target.getAttributeNames().indexOf("sensors-click") != -1) {
                let text = target.innerText;
                const getText = target.getAttribute("sensors-click");
                getText && (text = getText);
                console.log("sensors-click", text);
                this.sensorsAdd("BDWebClick", {
                    $element_content: text,
                    $title: "理念导入页",
                });
            }
        },
        bindInsurance() {
            if (this.relateInfo.isRelate === undefined) {
                return;
            }
            if (this.relateInfo.isRelate == true) {
                this.pdfPreview();
            } else {
                window.sessionStorage.setItem("INVESTADVISER_DIALOG", "show");
                this.$bindInsurance("/");
            }
        },
        pdfPreview() {
            let userAgent = window.navigator.userAgent;
            let pdfUrl = this.relateInfo.pdfUrl;
            if (userAgent.indexOf(" Android ") > -1) {
                let baseUrl =
                    location.origin + "/wmpages/pdfjs/web/viewer.html?url=";
                window.open(baseUrl + pdfUrl);
            } else {
                window.open(pdfUrl);
            }
            console.log("preview");
        },
    },
    watch: {
        "relateInfo.isRelate"(val) {
            if (val == true && this.tmrId) {
                let dialogDisabled = window.sessionStorage.getItem(
                    "INVESTADVISER_DIALOG"
                );
                if (dialogDisabled) {
                    window.sessionStorage.removeItem("INVESTADVISER_DIALOG");
                    this.$nextTick(() => {
                        this.$refs.dialog.download = this.relateInfo.hasNetGuarantee;
                        this.$refs.dialog.show = true;
                    });
                }
            }
        },
    },
    components: {
        PdfPreviewDialog,
        DocPreviewDialog,
    },
};
</script>

<style scoped>
.home {
    min-height: 100vh;
    background: #eef6ff;
}
.flex-box {
    display: flex;
    justify-content: space-between;
}
.box-shadow {
    border-radius: 0.1rem;
    box-shadow: 0rem 0rem 0.1rem #ebedf0;
}
img {
    width: 100%;
}
section {
    padding: 0 0.12rem;
}
li {
    padding: 0.06rem 0.2rem 0.06rem 0;
    margin: 0.15rem 0;
    background: white;
}
.home.tmr li {
    margin: 0.1rem 0;
    padding: 0.03rem 0.2rem 0.03rem 0;
}
li:nth-last-child(1) {
    padding: 0.06rem 0rem 0.06rem 0.2rem;
}
.home.tmr li:nth-last-child(1) {
    padding-left: 0.2rem;
}
li img {
    width: 1.2rem;
    height: 1.2rem;
}
li > div > p {
    font-size: 0.15rem;
    font-weight: bold;
    color: #1b3654;
    line-height: 0.35rem;
}
li > div > span {
    font-size: 0.11rem;
    font-weight: 500;
    color: #617080;
    line-height: 0.17rem;
}
.btn-box div {
    width: 1.5rem;
    text-align: center;
    height: 0.37rem;
    line-height: 0.37rem;
    border-radius: 0.37rem;
    background: #3b97ff;
    font-size: 0.15rem;
    font-weight: bold;
    color: #ffffff;
}
.guide-btn {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    margin: 0.1rem 0;
    color: #3b97ff;
    border-bottom: 1px solid #3b97ff;
}
</style>
